module.exports = __webpack_public_path__ + "static/img/bc_img.808308f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Desktop/About_Us/bc_img.png
// module id = R6he
// module chunks = 0